import styles from "./PracticeModeSelector.module.scss";

const PracticeModeSelector = ({ selectedMode, onModeSelect, topicName = "SAT Practice" }) => {
    const practiceMode = {
        UNLIMITED: 'unlimited',
        SECTION_25: 'section_25'
    };

    return (
        <div className={styles.modeSelectorContainer}>
            <div className={styles.modeSelectorContent}>
                <div className={styles.header}>
                    <h1 className={styles.title}>Select Your Practice Mode</h1>
                    <p className={styles.subtitle}>for "{topicName}"</p>
                    <p className={styles.description}>Choose how you want to practice today</p>
                </div>

                <div className={styles.modeCards}>
                    <div
                        className={`${styles.modeCard} ${selectedMode === practiceMode.UNLIMITED ? styles.selected : ''}`}
                        onClick={() => onModeSelect(practiceMode.UNLIMITED)}
                    >
                        <div className={styles.modeCardHeader}>
                            <div className={styles.modeIcon}>
                                <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M20 10V30M10 20H30" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
                                    <circle cx="20" cy="20" r="15" stroke="currentColor" strokeWidth="2.5" strokeDasharray="3 3" />
                                </svg>
                            </div>
                            <div className={styles.selectionIndicator}>
                                {selectedMode === practiceMode.UNLIMITED && (
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path d="M20 6L9 17L4 12" stroke="#220ec9" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                )}
                            </div>
                        </div>
                        <h3 className={styles.modeCardTitle}>Unlimited Mode</h3>
                        <p className={styles.modeCardDescription}>
                            Practice continuously with adaptive questions.
                        </p>
                        <ul className={styles.modeFeatures}>
                            <li>Continuous practice session</li>
                            <li>Adaptive difficulty</li>
                            <li>Stop anytime</li>
                        </ul>
                    </div>

                    <div
                        className={`${styles.modeCard} ${selectedMode === practiceMode.SECTION_25 ? styles.selected : ''}`}
                        onClick={() => onModeSelect(practiceMode.SECTION_25)}
                    >
                        <div className={styles.modeCardHeader}>
                            <div className={styles.modeIcon}>
                                <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="8" y="8" width="24" height="24" rx="4" stroke="currentColor" strokeWidth="2.5" />
                                    <path d="M15 20H25M20 15V25" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
                                </svg>
                            </div>
                            <div className={styles.selectionIndicator}>
                                {selectedMode === practiceMode.SECTION_25 && (
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path d="M20 6L9 17L4 12" stroke="#220ec9" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                )}
                            </div>
                        </div>
                        <h3 className={styles.modeCardTitle}>25 Questions Section</h3>
                        <p className={styles.modeCardDescription}>
                            Test-like practice with 25 focused questions.
                        </p>
                        <ul className={styles.modeFeatures}>
                            <li>Fixed 25 questions</li>
                            <li>Test-like experience</li>
                            <li>Complete section review</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PracticeModeSelector;
